// Тулбар форматирования живёт в правой панели, а редактор — в канвасе.
// Активный редактор публикуется здесь, чтобы панель могла им командовать.
import { createContext, useContext, useState, type ReactNode } from 'react'
import type { Editor } from '@tiptap/react'

interface TextEditorContextValue {
  activeEditor: Editor | null
  setActiveEditor: (editor: Editor | null) => void
}

const TextEditorContext = createContext<TextEditorContextValue>({
  activeEditor: null,
  setActiveEditor: () => {},
})

// eslint-disable-next-line react-refresh/only-export-components
export const useTextEditor = (): TextEditorContextValue => useContext(TextEditorContext)

export const TextEditorProvider = ({ children }: { children: ReactNode }) => {
  const [activeEditor, setActiveEditor] = useState<Editor | null>(null)
  return (
    <TextEditorContext.Provider value={{ activeEditor, setActiveEditor }}>
      {children}
    </TextEditorContext.Provider>
  )
}
